import { createServiceToken } from "@nasam/kernel";
import type { CameraRepository } from "./features/assetCameras/domain";
import type { AssetAssignmentsRepository } from "./features/assetAssignments/domain";
import type { DriverAssignmentsRepository } from "./features/driverAssignments/domain";
import type { GeofencesRepository } from "./features/geofences/domain";
import type { PoisRepository } from "./features/pois/domain";
import type {
  TrackingRepository,
  VehicleTrackingStream,
} from "./features/tracking/domain";

export const trackingRepositoryToken = createServiceToken<TrackingRepository>(
  "fleet-monitoring.tracking.repository",
);

export const cameraRepositoryToken = createServiceToken<CameraRepository>(
  "fleet-monitoring.cameras.repository",
);

export const vehicleTrackingStreamToken =
  createServiceToken<VehicleTrackingStream>("fleet-monitoring.tracking.stream");

export const assetAssignmentsRepositoryToken =
  createServiceToken<AssetAssignmentsRepository>(
    "fleet-monitoring.asset-assignments.repository",
  );

export const driverAssignmentsRepositoryToken =
  createServiceToken<DriverAssignmentsRepository>(
    "fleet-monitoring.driver-assignments.repository",
  );

export const poisRepositoryToken = createServiceToken<PoisRepository>(
  "fleet-monitoring.pois.repository",
);

export const geofencesRepositoryToken = createServiceToken<GeofencesRepository>(
  "fleet-monitoring.geofences.repository",
);
